import videojs from "!video.js";
import {FilterComponent} from "./FilterComponent";

const Component = videojs.getComponent('Component')

export class GuestPlayComponent extends Component {


    // The constructor of a component receives two arguments: the
    // player it will be associated with and an object of options.
    constructor(player, options = {}) {
        // It is important to invoke the superclass before anything else,
        // to get all the features of components out of the box!
        super(player, options);
    }

    createEl() {
        const container = videojs.dom.createEl('div', {
            // Prefixing classes of elements within a player with "vjs-"
            // is a convention used in Video.js.
            className: 'vjs-action-container',
            innerHTML: this.getPlayDOMContent()
        });

        const actionable = container.querySelector('.actionable')

        actionable.onclick = () => this.options_.clickAction()

        return container;
    }

    getPlayDOMContent() {
        return `<div class="vjs-play-action-container actionable">
            <img src="https://storage.googleapis.com/corsi-uploads/corsi-player/inizia.webp" alt="video play"/>
        </div>`;
    }
}